export let serverBaseUrl = "https://web3setu.co.in";

switch (process.env.NODE_ENV) {
  case "development":
    serverBaseUrl = "https://web3setu.co.in";
    break;
  case "production":
    serverBaseUrl = "https://web3setu.co.in";
    break;
  default:
    break;
}
